// Extracts the first sentence from a business description, handling abbreviations like "Inc."
const getFirstSentence = (description: string | undefined | null): string => {
  if (!description) {
    return '';
  }

  // Match a period followed by a space and a capital letter (sentence end)
  // or a period at the end of the string
  const sentenceEndRegex = /\.(\s+[A-Z]|$)/;
  const match = description.match(sentenceEndRegex);

  if (match && match.index !== undefined) {
    // Return the text up to and including the period
    return description.substring(0, match.index + 1).trim();
  }

  // If no sentence end found, return the entire description
  return description.trim();
};

export default getFirstSentence;
